import React from "react";
import { isArray } from "lodash";
import { _getTranslation } from "../utils/helper";

const CardTender = ({ data, ...props }) => {
  return (
    <div className="card-tender border-b sm:border-b-0 sm:border-l border-ideaListGrey100 sm:pb-0 sm:px-8 lg:px-12">
      <h3 className="card-tender__title h3 !mb-6">{data.title}</h3>
      <div className="text-mobileS md:text-desktopS">
        <table className="text-mobileS md:text-desktopS w-full mb-6 child-th:text-left child-td:text-right">
          <tbody>
            {data.publishedDate && (
              <tr>
                <th>{_getTranslation("published")}</th>
                <td>{data.publishedDate}</td>
              </tr>
            )}

            {data.deadlineForClarifications && (
              <tr>
                <th>{_getTranslation("deadline_for_clarifications")}</th>
                <td>{data.deadlineForClarifications}</td>
              </tr>
            )}

            {data.deadlineForSubmissions && (
              <tr>
                <th>{_getTranslation("deadline_for_submissions")}</th>
                <td>{data.deadlineForSubmissions}</td>
              </tr>
            )}
          </tbody>
        </table>
        {isArray(data.documents) && data.documents.length > 0 && (
          <React.Fragment>
            <div className="font-bold mb-2">
              {_getTranslation("documents")}
            </div>
            <ul className="tema-list tm--blue tm--hover---underline mb-6">
              {data.documents.map((doc, i) => (
                <li>
                  <a href={doc.fileUrl}>{doc.fileDescription}</a>
                </li>
              ))}
            </ul>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default CardTender;
